const PARAGRAPH_BOUNDARY_PREFERENCE = Object.freeze({
    BREAK_BEFORE: "break-before",
    JOIN_WITH_PREVIOUS: "join-with-previous",
});

function normalizeParagraphBoundaryPreference(value){
    if(
        value === PARAGRAPH_BOUNDARY_PREFERENCE.BREAK_BEFORE
        || value === PARAGRAPH_BOUNDARY_PREFERENCE.JOIN_WITH_PREVIOUS
    ){
        return value;
    }
    return null;
}

const ParagraphBoundaryPreference = {
    VALUES: PARAGRAPH_BOUNDARY_PREFERENCE,

    normalize: normalizeParagraphBoundaryPreference,

    isBreakBefore: function(value){
        return normalizeParagraphBoundaryPreference(value) === PARAGRAPH_BOUNDARY_PREFERENCE.BREAK_BEFORE;
    },

    isJoinWithPrevious: function(value){
        return normalizeParagraphBoundaryPreference(value) === PARAGRAPH_BOUNDARY_PREFERENCE.JOIN_WITH_PREVIOUS;
    },
};

export default ParagraphBoundaryPreference;
